import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from 'jquery';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import {
    Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Input,
    InputGroup, InputGroupAddon, Nav, Navbar, NavbarBrand, Row, UncontrolledDropdown
} from 'reactstrap';
import { Dispatch } from 'redux';
import { Application,  User } from '../../clients/aasServerClient.generated';
import { showAlert } from '../../stores/alerts/actionCreators';
import { Alert } from '../../stores/alerts/actions';
import { getAllApplications } from '../../stores/applications/selectors';
import { getSelfInfo, goToApplication, goToZendesk, logoutAs, resetLoadingApplication } from '../../stores/auth/actionCreators';
import { currentUser, getSelfApplications, hasPrivilege, isAdmin, isLoggedInAs, themeIconImage, themeOrgName, loadingApplication, ssoEnabled, organizationName, adEnabled } from '../../stores/auth/selectors';
import { isLoading } from '../../stores/navigation/selectors';
import { RootState } from '../../stores/store';
import LoadingScreen from '../navigation/LoadingScreen';
import './AppSelectionPage.scss';

export interface Props extends RouteComponentProps, LocalizeContextProps {
    loggedInAs: boolean;
    isAdmin?: boolean;
    applications?: Application[];
    themeIconImage?: string;
    themeOrgName?: string;
    currentUser: User;
    loading: boolean;
    loadingApplication: boolean;
    ssoEnabled: boolean;
    adEnabled?: boolean;
    organizationName: string;

    hasPrivilege: (privileges: string[]) => boolean;

    logoutAs: (checkSelf?: boolean) => void;
    getSelfInfo: () => void;
    goToApplication: (id: string) => void;
    goToZendesk: () => void;
    showAlert: (alert: Alert) => void;
    resetLoadingApplication: () => void;
}

export interface State {
    search: string;
    showAbout: boolean;
    // HACK get URL parameters as router does not give it. Should refactor.
    errorApp?: string | null;
    errorMessage?: string | null;
    // END HACK
}

class AppSelectionPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            search: '',
            showAbout: false,
        };
    }

    private onPageShow = (event: PageTransitionEvent) => {
        if (event.persisted && this.props.loadingApplication) {
            this.props.resetLoadingApplication();
        }
    };

    public componentDidMount() {
        window.addEventListener('pageshow', this.onPageShow);
        this.props.getSelfInfo();
        // HACK get URL parameters as router does not give it. Should refactor.
        const params: { [key: string]: string } = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
            params[key] = value;
            return '';
        });

        const extraMessage = params.extraMessage ? decodeURIComponent(params.extraMessage) : undefined;

        this.setState({
            errorApp: params.errorApp,
            errorMessage: params.errorMessage
        });
        if (params.errorMessage !== undefined) {
            this.props.showAlert({
                color: 'danger',
                // tslint:disable-next-line:no-any
                message: {
                    errorCode: 'SERVER_ERROR',
                    message: params.errorMessage,
                    extraMessage: extraMessage
                },
                title: 'Error',
                type: 'error'
            });
        }
        // END HACK
    }

    public componentWillUnmount() {
        window.removeEventListener('pageshow', this.onPageShow);
    }

    private isLocalhost = Boolean(
        window.location.hostname === 'localhost' ||
          // [::1] is the IPv6 localhost address.
          window.location.hostname === '[::1]' ||
          // 127.0.0.1/8 is considered localhost for IPv4.
          window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
          )
      );

    public render() {
        const t = this.props.translate;
        let showHostname = false;
        let logo = <div className="logo" />;
        if (this.props.organizationName) {
            logo = <h1>{this.props.organizationName}</h1>;
        }
        if (this.props.applications && !this.props.loadingApplication) {
            if (!this.props.loggedInAs && !this.props.loading &&
                this.props.isAdmin === false && this.props.applications.length === 1 &&
                this.state.errorApp === undefined && this.state.errorMessage === undefined) {
                const app = this.props.applications[0];
                // this.goToApp(app);
                return <div />;
            } else {
                if (this.props.applications.length > 0) {
                    const hostName = this.props.applications[0].server.hostname;
                    showHostname = this.props.hasPrivilege(['SUPER_ADMIN', 'ADMIN']);
                }
                const apps = this.filterApplications(this.props.applications, this.state.search)
                    .map((app: Application, i: number) => (
                     
                        <Col sm={2} className="p-3" key={i}>
                            <Button
                                className={
                                    // tslint:disable-next-line:max-line-length
                                    `w-100 px-0 py-4 selectApp-btn${!app.color || app.color === '' ? ' selectApp-btn-default' : ''}${app.location_path.toUpperCase() === this.state.errorApp?.toUpperCase() ? ' selectApp-btn-error' : ''}`
                                }
                                style={{ backgroundColor: app.color }}
                                // tslint:disable-next-line:prefer-template
                                onClick={() => this.goToApp(app)}
                            ><div className="mb-2"> <FontAwesomeIcon icon={['fas', 'laptop']} /></div>

                                <div className="py-2 textContainer"><div className="panelTitleHover">{app.title} </div> 
                                <div className="panelTitle">{app.title}           {showHostname ? <small><div className="mt-2">{app.server!.hostname}</div></small>
                                    : <small><div className="mt-2"></div></small>}</div>
                         
                                    
                                </div>
                            </Button>
                        </Col>
                    ));
                return (
                    <div className="main-continer">
                        <Navbar className="text-white selectApp-nav" expand="md">
                            <NavbarBrand>
                                <div className="header-heading">
                                    {logo}
                                <FontAwesomeIcon icon={['fas', 'horizontal-rule']} rotation={90}/>
                                   {/* <h2>{this.props.themeOrgName ? this.props.themeOrgName : ''}</h2>  */}
                            <h1>{t('appSelection.header.applications')}</h1>
                                </div>
                            </NavbarBrand>
                            <Nav className="ml-auto" navbar={true}>
                           
                            <div className="bottombar bottombar-search p-0" >
                                <Row className="m-0">
                                    <Col sm={6} lg={12} className="p-0">
                                    {this.props.isAdmin ? (
                                        <Button
                                        color="light"
                                            className="shadow-none inline-block icon-btn  px-3"
                                            onClick={() => this.props.history.push('/users')}
                                        >
                                            <FontAwesomeIcon icon={['fal', 'cogs']} />
                                        </Button>
                                    ) : null}
                                    {this.props.isAdmin ? (
                                        <Button
                                        color="light"
                                            className="shadow-none inline-block icon-btn px-3"
                                            onClick={() => this.props.goToZendesk()}
                                        >
                                            <FontAwesomeIcon
                                                icon={['fal', 'question-circle']}
                                            />
                                        </Button>
                                    ) : null}
                            </Col>
                           </Row>
                            </div> 
                            {this.props.loggedInAs ? (
                                    <div className="navbar-text">
                                        {t('appSelection.button.loggedInAs')}
                                    </div>
                                ) : null
                                }  
                                <UncontrolledDropdown nav={true} inNavbar={true}>
                                    <DropdownToggle nav={true} caret={true}>
                                    <FontAwesomeIcon
                                                    icon={['fas', 'user']}
                                                /> {this.props.currentUser.is_old_user ?
                                            this.props.currentUser.username : this.props.currentUser.email}
                                    </DropdownToggle>
                                    <DropdownMenu right={true}>
                                        {this.props.loggedInAs ? (
                                            <DropdownItem className=""
                                                onClick={() => {
                                                    this.props.logoutAs(true);
                                                }}
                                            >
                                                {t('appSelection.button.logoutAs')}
                                            </DropdownItem>
                                        ) : (
                                                <DropdownItem  className="" onClick={() => this.props.history.replace('/logout')}>
                                                    {t('appSelection.button.logout')}
                                                </DropdownItem>
                                            )}

                                        {(this.props.ssoEnabled || this.props.adEnabled) && !this.isLocalhost ? null : (
                                            <DropdownItem onClick={() => this.props.history.push('/change-password')}>
                                                {t('appSelection.button.changePassword')}
                                            </DropdownItem>
                                        )}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </Nav>
                        </Navbar>
                       
                        <div className="selectApp fluid-container view">
                            <Row className="m-0">
                                <Col sm={6} lg={2} className="sideMenu p-0">
                                    <div className="background-overlay"></div>
                                <InputGroup className="form-group">
                                            {/* <InputGroupAddon addonType="prepend">
                                                <span className="input-group-text">
                                                    <Icon name="search" className="noMarginRight" />
                                                </span>
                                            </InputGroupAddon> */}
                                            <Input
                                                autoFocus={true}
                                                className="shadow-none selectApp-search"
                                                value={this.state.search}
                                                onChange={this.handleSearchChange}
                                                onKeyPress={this.handleKeyPress}
                                                type="text"
                                                placeholder={t('appSelection.field.search') as string}
                                            />
                                            <InputGroupAddon addonType="append">
                                                <Button
                                                    style={{ outline: 'none' }}
                                                    className="inline-block shadow-none "
                                                    onClick={() => {
                                                        this.setState({ search: '' });
                                                        $('.selectApp-search').focus();
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={['fal', 'times']} />
                                                </Button>
                                            </InputGroupAddon>
                                        </InputGroup>
                                 </Col>
                                <Col sm={6} lg={{size: 10, offset: 2}} className="p-0">
                                    <div className="selectApp-container p-3"><Row className="m-0">{apps}</Row></div>
                             
                                </Col>
                            </Row>
                        </div>
                    </div >
                );
            }

        } else {
            return <LoadingScreen text={t('loading.loading') as string} />;
        }
    }

    private handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            search: event.target.value,
        });
    }

    private handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            const filteredApps = this.filterApplications(this.props.applications!, this.state.search);
            if (filteredApps.length > 0) {
                this.goToApp(filteredApps[0]);
            }
        }
    }

    private filterApplications = (applications: Application[], search: string): Application[] => {
        search = search.trim();
        return applications.filter((app) => {
            return (
                app.title!.toLowerCase().includes(search) ||
                app.help_url!.toLowerCase().includes(search) ||
                app.location_path!.toLowerCase().includes(search) ||
                (app.server?.hostname || '').toLowerCase().includes(search)
            );
        });
    }

    private goToApp = (app: Partial<Application>) => {
        this.props.goToApplication(app?.id || '');
    }

    /* private goToZendesk = () => {
        authRepository.getZendeskToken().then((res: { token: string, url: string }) => {*/
    // tslint:disable-next-line:max-line-length
    /* window.open(`${res.url}?jwt=${res.token}&return_to=${encodeURIComponent('https://helpcentrum.cogix.nl/hc/nl/articles/115001340713-Leerlingaantallen-en-overige-kerncijfers')}`, 'Helpcenter', 'height=800,width=1000');
});
} */

}

const mapStateToProps = (state: RootState) => ({
    applications: getSelfApplications(state),
    currentUser: currentUser(state)!,
    isAdmin: isAdmin(state),
    loading: isLoading(state),
    loggedInAs: isLoggedInAs(state),
    themeIconImage: themeIconImage(state),
    themeOrgName: themeOrgName(state),

    hasPrivilege: hasPrivilege(state),
    loadingApplication: loadingApplication(state),
    organizationName: organizationName(state),
    ssoEnabled: ssoEnabled(state),
    adEnabled: adEnabled(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getSelfInfo: () => dispatch(getSelfInfo()),
    goToApplication: (id: string) => dispatch(goToApplication(id)),
    goToZendesk: () => dispatch(goToZendesk()),
    logoutAs: (checkSelf?: boolean) => dispatch(logoutAs(checkSelf)),
    showAlert: (alert: Alert) => dispatch(showAlert(alert)),
    resetLoadingApplication: () => dispatch(resetLoadingApplication()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(AppSelectionPage)));